module.exports = __webpack_public_path__ + "static/foreground-09a43dc2a20c8cb3dd0e9b260e93240b.jpg";